export class ThrowStatus {
  static get Success () {
    return 1
  }
  static get Fail () {
    return 2
  }

  static ThrowStatusName (PayType) {
    let tmpType = parseInt(PayType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '成功'
        break
      case 2:
        name = '失敗'
        break
    }
    return name
  }
}
